import React from 'react';

import SignUpComponent from 'components/SignUp';

const SignUp: React.FC = () => <SignUpComponent />;

export default SignUp;
